<template>
    <Dialog v-model:visible="visible_" modal header="Редактирование ордера" @hide="close"
        class="border-none" 
        :style="{ width: '28rem' }">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
                <span class="text-xs font-medium">ID ордера</span>
                <span class="text-sm">{{ orderId }}</span>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-xs font-medium">Статус</span>
                <Select v-model="status_" :options="statusOptions" optionLabel="label" optionValue="value" class="w-full" >
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex items-center">
                            <Tag :value="getStatusTitle(slotProps.value)" :severity="getStatusSeverity(slotProps.value)" 
                                :class="(slotProps.value=='confirmed') ? 'bg-green-500 text-green-100' : ''"/>
                        </div>
                        <span v-else>
                            {{ slotProps.placeholder }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex flex-row gap-1 justify-content-start align-items-center">
                            <Tag class="flex" :value="getStatusTitle(slotProps.option.value)" :severity="getStatusSeverity(slotProps.option.value)"
                                :class="(slotProps.option.value=='confirmed') ? 'bg-green-500 text-green-100' : ''"/>
                        </div>
                    </template>
                </Select>
            </div>
            <div class="flex justify-content-end gap-2 mt-2">
                <Button label="Сохранить" size="small" :loading="loading" @click="save" />
                <Button label="Отмена" size="small" severity="secondary" @click="close" />
            </div>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    name: 'AdminOrderEdit',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: [Number, String],
            required: true
        },
        status: {
            type: String,
            default: 'pending'
        }
    },
    emits: ['update:modelValue', 'saved'],
    data() {
        return {
            visible_: false,
            status_: null,
            loading: false,
            statusOptions: [
                // { label: this.helper.getStatusTitle('pending'), value: 'pending' },
                // { label: this.helper.getStatusTitle('processing'), value: 'processing' },
                // { label: this.helper.getStatusTitle('paid'), value: 'paid' },
                { label: this.helper.getStatusTitle('confirmed'), value: 'confirmed' },
                { label: this.helper.getStatusTitle('canceled'), value: 'canceled' },
                // { label: this.helper.getStatusTitle('failed'), value: 'failed' }
            ]
        }
    },
    methods: {
        getStatusSeverity(status) {
            return this.helper.getStatusSeverity(status)
        },
        getStatusTitle(status) {
            return this.helper.getStatusTitle(status)
        },
        async save() {
            if (!this.orderId || !this.status_) return
            this.loading = true
            const data = {
                status: this.status_
            }
            try {
                const resp = await this.connect.EditAdminOrder({ id: this.orderId, data}).then(res=>res)
                if (resp && resp.result) {
                    this.$toast.add({ severity: 'success', summary: 'Сохранено', detail: 'Статус обновлен', life: 1500 })
                    this.$emit('saved', { id: this.orderId, status: this.status_ })
                    this.close()
                } else {
                    const message = (resp && resp.message) ? resp.message : 'Не удалось обновить статус'
                    this.$toast.add({ severity: 'warn', summary: 'Ошибка', detail: message, life: 2500 })
                }
            } catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка запроса', life: 1500 })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.visible_ = false
            this.$emit('update:modelValue', false)
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(v) {
                this.visible_ = v
            }
        },
        status: {
            immediate: true,
            handler(v) {
                this.status_ = v
            }
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>
